/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Asi_Statement_TextInputs */



/**

* @param {Home_Quotes_Asi_Statement_TextInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_quotes_asi_statement_text = /** @type {((inputs?: Home_Quotes_Asi_Statement_TextInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Asi_Statement_TextInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Pedimos la prohibición del desarrollo de la superinteligencia, que no se levante hasta que exista un amplio consenso científico de que se hará de forma segura y controlable, y un fuerte respaldo público")
});